/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { AssessmentCard } from 'src/languageStudio/appShell/prebuiltDemos/sentimentDemo/AssessmentCard';
import { ModifiedAssessment, ModifiedTarget } from 'src/languageStudio/appShell/prebuiltDemos/sentimentDemo/VisualizedSentimentResult';
import { getLabelId } from 'src/languageStudio/appShell/prebuiltDemos/utils/sentimentDemoUtils';
import { SentenceAssessment, SentenceTarget } from 'src/languageStudio/core/services/textAnalytics/textAnalyticsSwaggers';
import { Label } from 'src/modules/labeling/types/Label';

export type AssessmentLabelTooltipProps = {
    label: Label;
    targets: ModifiedTarget[];
    assessments: ModifiedAssessment[];
};

export const AssessmentLabelTooltip = (props: AssessmentLabelTooltipProps) => {
    const { label, targets, assessments } = props;

    let relatedTargets: SentenceTarget[] = [];
    let relatedAssessments: SentenceAssessment[] = [];
    const target = targets.find(t => getLabelId(t.sentenceIndex, t.targetIndex, 'target') === label.entity.id);
    const assessment = assessments.find(op => getLabelId(op.sentenceIndex, op.assessmentIndex, 'assessment') === label.entity.id);
    const isTargetCard = Boolean(target);

    if (isTargetCard) {
        relatedTargets = [target.target];
        relatedAssessments = assessments
            .filter(assessmentToFilter =>
                target.target.relations.some(
                    relation =>
                        relation.ref ===
                        `#/documents/0/sentences/${assessmentToFilter.sentenceIndex}/assessments/${assessmentToFilter.assessmentIndex}`
                )
            )
            .map(o => o.assessment);
    } else {
        relatedTargets = targets
            .filter(t =>
                t.target.relations.some(
                    relation =>
                        relation.ref === `#/documents/0/sentences/${assessment.sentenceIndex}/assessments/${assessment.assessmentIndex}`
                )
            )
            .map(a => a.target);
        relatedAssessments = [assessment.assessment];
    }

    return <AssessmentCard targets={relatedTargets} assessments={relatedAssessments} isTargetCard={isTargetCard} />;
};
